import React, { PropsWithChildren, Suspense, useEffect, useState } from 'react';
import { IRootState } from '../../Storage/Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import App from '../../Container/App';
import { toggleSidebar } from '../../Storage/Redux/slice/themeConfigSlice';
import { Footer, Header, Portals, Setting, Sidebar } from '../Pages/Layouts';
import { withAuth } from '../../HOC';
import { SD_Services } from '../../Utility/StaticDatas';
import { MainLoader } from '../Common';

function MCQTestLayout({ children }: PropsWithChildren) {
  const themeConfig = useSelector((state: IRootState) => state.themeConfig);
  const dispatch = useDispatch();

  const [showLoader, setShowLoader] = useState(true);
  const [showTopButton, setShowTopButton] = useState(false);

  const goToTop = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  const onScrollHandler = () => {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      setShowTopButton(true);
    } else {
      setShowTopButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScrollHandler);

    const screenLoader = document.getElementsByClassName('screen_loader');
    if (screenLoader?.length) {
      screenLoader[0].classList.add('animate__fadeOut');
      setTimeout(() => {
        setShowLoader(false);
      }, 200);
    }

    return () => {
      window.removeEventListener('onscroll', onScrollHandler);
    };
  }, []);

  return (
    <App>
      {/* BEGIN MAIN CONTAINER */}
      <div className="relative">
        {/* sidebar menu overlay */}
        <div
          className={`${(!themeConfig.sidebar && 'hidden') || ''} fixed inset-0 bg-[black]/60 z-50 lg:hidden`}
          onClick={() => dispatch(toggleSidebar())}
        ></div>
        {/* screen loader */}
        {showLoader && <MainLoader />}
        <div className="fixed bottom-6 ltr:right-6 rtl:left-6 z-50">
          {showTopButton && (
            <button
              type="button"
              className="btn btn-outline-primary rounded-full p-2 animate-pulse bg-[#fafafa] dark:bg-[#060818] dark:hover:bg-primary"
              onClick={goToTop}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8 7l4-4m0 0l4 4m-4-4v18"
                />
              </svg>
            </button>
          )}
        </div>

        <div className={`${themeConfig.navbar} main-container text-black dark:text-white-dark min-h-screen`}>
          {/* BEGIN TOP SIDEBAR */}
          {window.location.pathname !== '/' && (
            <Sidebar service={SD_Services.MCQTestService} />
          )}
          {/* END TOP SIDEBAR */}

          <div className={`${window.location.pathname !== '/' && 'main-content'} flex flex-col min-h-screen`}>
            {/* BEGIN NAVBAR */}
            <Header service={SD_Services.MCQTestService} />
            {/* END NAVBAR */}

            {/* BEGIN CONTENT AREA */}
            <Suspense>
              <div className={`${themeConfig.animation} ${window.location.pathname !== '/' && 'p-6'} animate__animated`}>
                {children}
              </div>
            </Suspense>
            {/* END CONTENT AREA */}

            {/* BEGIN FOOTER */}
            <Footer />
            {/* END FOOTER */}
            <Portals />
          </div>
        </div>
      </div>
    </App>
  );
}

export default withAuth(MCQTestLayout);
